import { Platform } from 'react-native';

import { firebaseConfig, isFirebaseEnabled } from './firebase.config';

let webFirebase: any = null;
let webAnalytics: any = null;

class FirebaseAnalyticsService {
	private initialized = false;
	private isWebPlatform = Platform.OS === 'web';

	async initialize() {
		if (!isFirebaseEnabled) {
			console.log('[Firebase] Analytics disabled (not production)');
			return;
		}

		if (this.initialized) return;

		// Only initialize on web platform
		if (!this.isWebPlatform) {
			console.log('[Firebase] Skipping initialization - not web platform');
			return;
		}

		try {
			await this.initializeWeb();
			this.initialized = true;
			console.log('[Firebase] ✅ Analytics initialized successfully');
		} catch (error) {
			console.error('[Firebase] ❌ Initialization failed:', error);
		}
	}

	private async initializeWeb() {
		const { initializeApp } = await import('firebase/app');
		const { getAnalytics } = await import('firebase/analytics');

		webFirebase = initializeApp(firebaseConfig);
		webAnalytics = getAnalytics(webFirebase);

		console.log('[Firebase] Web analytics initialized');
	}

	async setUserId(userId: string) {
		if (!this.initialized || !isFirebaseEnabled || !webAnalytics) return;

		try {
			const { setUserId: webSetUserId } = await import('firebase/analytics');
			webSetUserId(webAnalytics, userId);
			console.log(`[Firebase] User ID set: ${userId}`);
		} catch (error) {
			console.warn('[Firebase] Failed to set user ID:', error);
		}
	}

	async setUserProperty(property: string, value: any) {
		if (!this.initialized || !isFirebaseEnabled || !webAnalytics) return;

		try {
			const { setUserProperties } = await import('firebase/analytics');
			setUserProperties(webAnalytics, { [property]: value });
			console.log(`[Firebase] User property set: ${property} = ${value}`);
		} catch (error) {
			console.warn('[Firebase] Failed to set user property:', error);
		}
	}

	async logEvent(eventName: string, params?: Record<string, any>) {
		if (!this.initialized || !isFirebaseEnabled) {
			// console.log(`[Firebase] Would log: ${eventName}`, params);
			return;
		}

		if (!webAnalytics) {
			console.warn('[Firebase] Analytics not initialized');
			return;
		}

		try {
			const { logEvent: webLogEvent } = await import('firebase/analytics');
			webLogEvent(webAnalytics, eventName, params);
			console.log(`[Firebase] 📊 Event: ${eventName}`, params);
		} catch (error) {
			console.warn(`[Firebase] Failed to log event ${eventName}:`, error);
		}
	}

	async logScreenView(screenName: string, screenClass?: string) {
		await this.logEvent('screen_view', {
			firebase_screen: screenName,
			firebase_screen_class: screenClass || screenName,
		});
	}
}

export const firebaseAnalytics = new FirebaseAnalyticsService();
